import remarkGfm from 'remark-gfm';

var strike = "Strikethrough";
var strikeText = "text";
var task = "Task list";
var taskText = "todo";
var table = "Table";
var tableHeading = "Heading";
var en = {
	strike: strike,
	strikeText: strikeText,
	task: task,
	taskText: taskText,
	table: table,
	tableHeading: tableHeading
};

// DO NOT EDIT, generated by scripts/icon.js
const icons = {
    strikethrough: '<svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 24h38M24 24c16 6 10 20 0 20s-12-8-12-8M36 12s-3-8-12-8-12.564 7.6-8.39 14" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 36s4 8 12 8 12.564-7.6 8.39-14" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    task: '<svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><path d="M42 20v19a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h21"/><path d="m16 20 10 8L41 7"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h48v48H0z"/></clipPath></defs></svg>',
    table: '<svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M39.3 6H8.7A2.7 2.7 0 0 0 6 8.7v30.6A2.7 2.7 0 0 0 8.7 42h30.6a2.7 2.7 0 0 0 2.7-2.7V8.7A2.7 2.7 0 0 0 39.3 6z" stroke="currentColor" stroke-width="4"/><path d="M18 6v36M30 6v36M6 18h36M6 30h36" stroke="currentColor" stroke-width="4" stroke-linecap="round"/></svg>',
};

function gfm({ locale: _locale, ...remarkGfmOptions } = {}) {
    const locale = { ...en, ..._locale };
    return {
        remark: (p) => p.use(remarkGfm, remarkGfmOptions),
        actions: [
            {
                title: locale.strike,
                icon: icons.strikethrough,
                cheatsheet: `~~${locale.strikeText}~~`,
                handler: {
                    type: 'action',
                    click({ wrapText, editor }) {
                        wrapText('~~');
                        editor.focus();
                    },
                },
            },
            {
                title: locale.task,
                icon: icons.task,
                cheatsheet: `- [ ] ${locale.taskText}`,
                handler: {
                    type: 'action',
                    click({ replaceLines, editor }) {
                        replaceLines((line) => '- [ ] ' + line);
                        editor.focus();
                    },
                },
            },
            {
                title: locale.table,
                icon: icons.table,
                handler: {
                    type: 'action',
                    click({ editor, appendBlock, codemirror }) {
                        const { line } = appendBlock(`| ${locale.tableHeading} |  |\n| --- | --- |\n|  |  |\n`);
                        editor.setSelection(codemirror.Pos(line, 2), codemirror.Pos(line, 2 + locale.tableHeading.length));
                        editor.focus();
                    },
                },
            },
        ],
    };
}

export { gfm as default };
//# sourceMappingURL=index.esm.js.map
